import { CTAButton } from 'components/CTAButton/CTAButton';
import React from 'react';

import { cx } from '@emotion/css';
import { FAQsView } from '@modules/shared/FAQs/FAQsView';

import { AreasWeCover } from '../AreasWeCover';
import { ListOfServices } from '../ListOfServices';
import { PostCodes } from '../PostCodes';
import { EmergencyComponent } from '../shared/EmergencyComponent';
import { HeroComponent } from '../shared/HeroComponent';
import { ServiceItem } from '../shared/ServiceItem';
import { TitleAndDescComponent } from '../shared/TitleAndDescComponent';
import styles from './Plumbing.module.scss';

export const Plumbing = () => {
  return (
    <>
      <HeroComponent
        styles={styles}
        imageLink="/images/services/plumbing/plumbing.jpeg"
        imageAlt="Plumbing banner image"
        title="Plumbing"
      />

      <section className={styles.services}>
        <div className={styles.root}>
          <div className={styles.services_card_block}>
            <div className={styles.container}>
              <div className={styles.inner_section}>
                <TitleAndDescComponent
                  styles={styles}
                  title="Trusted Plumbing Services in London"
                  description="Your trusted partner for all plumbing needs in London—from drippy taps to mysterious leaks, our professional plumbers are here to keep your water flowing smoothly. Quick and hassle free service."
                />

                <CTAButton
                  title="Book a Plumber online"
                  serviceName="Plumbing"
                />

                <div
                  className={cx(
                    styles.wrap_section,
                    styles.service_content_container,
                  )}>
                  <TitleAndDescComponent
                    styles={styles}
                    subTitle="Expert Plumbing Services"
                  />
                  <div className={styles.service_items}>
                    <ServiceItem
                      styles={styles}
                      imgSrc="/images/services/plumbing/plumbing-repair.webp"
                      imgAlt="plumbing repair"
                      title="Plumbing repairs"
                      description="From dripping faucets to pipe bursts, our comprehensive plumbing repair service tackles it all. Our skilled technicians swiftly diagnose and resolve issues, preventing escalation and restoring normalcy. Armed with expertise and cutting-edge tools, our team delivers efficient, durable solutions for any plumbing challenge, making sure your system flows flawlessly."
                    />
                    <ServiceItem
                      styles={styles}
                      imgSrc="/images/services/plumbing/plumbing-blocked-drain.webp"
                      imgAlt="plumbing blocked drain"
                      title="Blocked drains"
                      description="Blocked drains can cause significant disruption and even lead to water damage if left untreated. Our London plumbing team specialises in unblocking drains, using advanced tools and techniques to restore your drainage system to full functionality. Whether it’s a kitchen sink or a main drain, we handle it all effectively."
                    />
                    <ServiceItem
                      styles={styles}
                      imgSrc="/images/services/plumbing/plumbing-leak-investigation.webp"
                      imgAlt="plumbing leak investigation"
                      title="Leak investigation"
                      description="Undetected leaks can silently wreak havoc on your home and wallet. Our expert leak detection service swiftly pinpoints hidden water escapes before they become costly nightmares. Equipped with cutting-edge technology, our local specialists precisely locate the source of trouble and implement durable fixes. Trust us to keep your home safe and dry."
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <EmergencyComponent
        title="Emergency Plumbing in London"
        imageSrc="/images/services/plumbing/plumbing-emergency.jpeg"
        imageAlt="Emergency plumbing services"
        styles={styles}
        para1="Plumbing problems can be a real drain on your day and become costly if left unchecked. Our professional plumbing service in London is here to help, whether you need plumbing repairs, blocked drains dealt with, or leak investigation."
        para2="Our experienced team of professional plumbers and pipefitters is ready and available 7 days a week to tackle your plumbing issues head-on—from minor hiccups to major catastrophes, we’ve got you covered. Book a plumber online today to keep your pipes in top shape and flush your worries away!"
      />

      <ListOfServices
        styles={styles}
        serrviceList={[
          { name: 'Tap repairs and installation' },
          { name: 'Toilet repairs and installation' },
          { name: 'Bath repairs and installation' },
          { name: 'Shower repair and installation' },
          { name: 'Appliance plumbing' },
          { name: 'Pumps' },
          { name: 'Low water pressure issues' },
          { name: 'Water tanks' },
          { name: 'Blocked toilets, sinks, showers and drains' },
          { name: 'Macerator blockages and repair' },
          { name: 'Leak investigation and repair' },
        ]}
      />
      <AreasWeCover styles={styles} />
      <PostCodes styles={styles} mainPageUrl="/services/plumbing" />
      <FAQsView title="Plumbing FAQs" faqItems={faqItems} />
    </>
  );
};

const faqItems = [
  {
    title: 'How often should I have my plumbing system inspected?',
    details: `It’s recommended to have your plumbing inspected annually to catch any potential issues early and ensure everything is functioning properly.`,
  },
  {
    title: 'What should I do if I have a leaking pipe?',
    details:
      'Turn off the water supply immediately to prevent further damage, then call a plumber to assess and fix the leak.',
  },
  {
    title: 'Why is my water pressure low?',
    details: `Low water pressure can result from clogged pipes, a faulty pressure regulator, or issues with the main water supply. A plumber can diagnose the cause and suggest the best solution.`,
  },
  {
    title: 'How can I prevent frozen pipes in winter?',
    details: `Insulate your pipes, keep your heating on a low setting, and let taps drip slightly during extreme cold. A plumber can advise on further steps to protect your pipes from freezing.`,
  },
  {
    title: 'Do your plumbers offer guarantees on their work?',
    details: `We offer a 12-month guarantee on all work done by our Qeeper tradespeople, covering any faulty workmanship.`,
  },
];
